import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLabel32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLabel32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.1 14.757V7.1h7.657a2 2 0 0 1 1.415.586l10.142 10.142a2 2 0 0 1 0 2.829l-5.657 5.657a2 2 0 0 1-2.829 0L7.686 16.172a2 2 0 0 1-.585-1.415m-.828 2.829a4 4 0 0 1-1.171-2.829V7.1a2 2 0 0 1 2-2h7.656a4 4 0 0 1 2.829 1.172l10.142 10.142a4 4 0 0 1 0 5.657l-5.657 5.657a4 4 0 0 1-5.657 0zM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLabel32);
